module.exports = __webpack_public_path__ + "static/img/qingdao-index.ac7feb94.jpg";